export default function MinusIcon({ className }: { className?: string }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      className={className}
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3.97363 10.9531C3.81315 10.9531 3.66374 10.9116 3.52539 10.8286C3.38704 10.7401 3.2736 10.6266 3.18506 10.4883C3.09652 10.3444 3.05225 10.1867 3.05225 10.0151C3.05225 9.84912 3.09652 9.69417 3.18506 9.55029C3.2736 9.40641 3.38704 9.29297 3.52539 9.20996C3.66374 9.12695 3.81315 9.08545 3.97363 9.08545H16.0181C16.1785 9.08545 16.328 9.12695 16.4663 9.20996C16.6102 9.29297 16.7236 9.40641 16.8066 9.55029C16.8952 9.69417 16.9395 9.84912 16.9395 10.0151C16.9395 10.1867 16.8952 10.3444 16.8066 10.4883C16.7236 10.6266 16.6102 10.7401 16.4663 10.8286C16.328 10.9116 16.1785 10.9531 16.0181 10.9531H3.97363Z" />
    </svg>
  );
}
